import { html, ref, repeat, sync } from '@genesislcap/web-core';
import {
  TODAYS_ACTIVITY_GRID_COLUMNS,
} from "../../../../mbm/utils/column-config";
import { CriteriaSegmentedControl } from '@genesislcap/foundation-criteria';
import type { ActivityTodayRoute } from './activity-today';
import {ColDef} from '@ag-grid-community/core';
CriteriaSegmentedControl;

export const ActivityTodayTemplate = html<ActivityTodayRoute>`
  <!-- Header with Filters button -->
  <div class="activity-today-header">
    <div class="controls">
      <rapid-label>Filters:</rapid-label>

      <rapid-text-field
        class="text-filter"
        placeholder="CUSIP..."
        :value=${sync((x) => x.cusipFilterValue)}
      ></rapid-text-field>

      <rapid-text-field
        class="text-filter"
        placeholder="Reference #..."
        :value=${sync((x) => x.referenceFilterValue)}
      ></rapid-text-field>

      <rapid-text-field
        class="text-filter"
        placeholder="Issuer..."
        :value=${sync((x) => x.issuerFilterValue)}
      ></rapid-text-field>

      <rapid-text-field
        class="text-filter"
        placeholder="Trader..."
        :value=${sync((x) => x.traderFilterValue)}
      ></rapid-text-field>

      <criteria-segmented-control
        :criteriaOptions=${(x) => x.activityOptions}
        :value=${sync((x) => x.activityCriteriaValue)}
        ${ref('activityCriteria')}
      ></criteria-segmented-control>

      <rapid-button style="font-weight: 600; min-width: 140px;" @click=${(x) => x.clearAllFilters()}>
        <span slot="start"style="display: inline-flex; align-items: center; margin-right: 8px;">
          <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle;">
            <g>
              <path d="M 0.3738281249999995 1.7691406250000001  C 0.21249999999999958 1.575  0.12499999999999956 1.3316406250000001  0.12499999999999956 1.080078125  C 0.12499999999999956 0.48398437499999997  0.6089843749999995 0  1.2050781249999996 0  L 13.044921875 0  C 13.641015625 0  14.125 0.48398437499999997  14.125 1.080078125  C 14.125 1.3316406250000001  14.0375 1.575  13.876171874999999 1.7691406250000001  L 10.90390625 5.362109375  C 10.23671875 5.50703125  9.61875 5.794140625  9.088281249999998 6.1851562499999995  L 13.203515625 1.2113281249999999  C 13.23359375 1.17578125  13.25 1.1292968749999999  13.25 1.080078125  C 13.25 0.9652343749999999  13.157031250000001 0.875  13.044921875 1  L 1.2050781249999996 1  C 1.0902343749999994 0.875  0.9999999999999996 0.9679687499999999  0.9999999999999996 1.080078125  C 0.9999999999999996 1.1292968749999999  1.0164062499999997 1.173046875  1.0464843749999997 1.2113281249999999  L 6.148828125 7.3773437500000005  C 6.214453125 7.4566406249999995  6.25 7.5550781250000005  6.25 7.65625  L 6.25 10.06796875  L 7.1796875 10.78984375  C 7.253515624999999 11.284765625  7.406640625 11.755078124999999  7.619921875000001 12.189843749999998  C 7.53515625 12.15703125  7.453125 12.113281249999998  7.382031250000001 12.055859374999999  L 5.714062500000001 10.759765625  C 5.500781250000001 10.592968749999999  5.375 10.338671875000001  5.375 10.06796875  L 5.375 7.8148437500000005  L 0.3738281249999995 1.7691406250000001  Z M 15 10.0625  C 15 8.371127953643196  13.628872046356802 7  11.937499999999998 7  C 10.246127953643194 7  8.874999999999998 8.371127953643196  8.874999999999998 10.0625  C 8.874999999999998 11.753872046356804  10.246127953643194 13.125  11.937499999999998 13.125  C 13.628872046356802 13.125  15 11.753872046356804  15 10.0625  Z M 11.9375 14  C 9.762878797541251 14  8 12.237121202458747  8 10.0625  C 8 7.88787879754125  9.762878797541251 6.124999999999999  11.9375 6.124999999999999  C 14.112121202458749 6.124999999999999  15.875 7.88787879754125  15.875 10.0625  C 15.875 12.237121202458747  14.112121202458749 14  11.9375 14  Z M 13.558984375 8.441015625  C 13.728515625000002 8.610546874999999  13.728515625 8.889453125  13.558984375 9.058984375  L 12.555468750000001 10.0625  L 13.558984375 11.066015625  C 13.728515625 11.235546874999999  13.728515625 11.514453125  13.558984375 11.683984375  C 13.389453125000001 11.853515625000002  13.110546875 11.853515625  12.941015625 11.683984375  L 11.9375 10.680468750000001  L 10.933984375 11.683984375  C 10.764453125000001 11.853515625  10.485546875 11.853515625  10.316015625 11.683984375  C 10.146484374999998 11.514453125000001  10.146484375 11.235546875  10.316015625 11.066015625  L 11.319531249999999 10.0625  L 10.316015625 9.058984375  C 10.146484375 8.889453125000001  10.146484375 8.610546875  10.316015625 8.441015625  C 10.485546874999999 8.271484374999998  10.764453125 8.271484375  10.933984375 8.441015625  L 11.9375 9.444531249999999  L 12.941015625 8.441015625  C 13.110546874999999 8.271484375  13.389453125 8.271484375  13.558984375 8.441015625  Z " fill-rule="evenodd" fill="rgba(135, 155, 166, 1)"/>
            </g>
          </svg>
        </span>
        Clear All Filters
      </rapid-button>
    </div>
  </div>

  <div class="activity-today-main-container">
    <mbm-grid-pro
      with-status-bar
      persist-column-state-key=${x => x.todaysActivityGridStateKey}
      enable-row-flashing
      enable-cell-flashing
      only-template-col-defs
    >
    ${repeat(
        () => TODAYS_ACTIVITY_GRID_COLUMNS,
        html<ColDef>`
        <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
        `,
    )}
    <grid-pro-genesis-datasource
        resource-name="CPTY_BOND_ACTIVITY"
        :deferredGridOptions=${(x) => x.gridOptions}
        criteria=${sync((x) => x.filterValue)}
        max-rows="1000"
        max-view="15000"
    ></grid-pro-genesis-datasource>
    </mbm-grid-pro>
  </div>

  <rapid-flyout :closed=${(x) => !x.bondDetailsOpen} @closed=${(x) => x.handleFlyoutClosed()}>
    <div slot="title">Bond Detail (${(x) => x.selectedBondId})</div>
    <tranche-detail-flyout
      ${ref('trancheDetail')}
      @close=${(x) => x.handleFlyoutClosed()}
    ></tranche-detail-flyout>
  </rapid-flyout>
`; 
